import React from 'react'

function Events() {


    return (

        <div className="wedding">
            <img alt="events-img" src='/parallax/pngegg (12).png' className="header" />
            <br />
            <br />
            <br />
            <h3>ARRIVAL</h3>
            <p>3:30 PM, June 9, 2023</p>
            <p>141 Mercer Lane, Grafton, Ontario, K0K 2G0</p>
            <br />
            <h3>WEDDING CEREMONY</h3>
            <p>4:00 PM - 4:30 PM, June 9, 2023</p>
            <p>Whispering Springs Chapel</p>
            <p>Ceremony will be outdoors in a forested area. Please dress according to the weather and conditions.</p>
            <br />
            <h3>RECEPTION</h3>
            <p>4:30 PM - 12:30 AM, June 9-10, 2023</p>
            <p>Whispering Springs Watering Hole</p>
            <br />
            <img alt="top-vine" className="top-vine" src='assets/Frame 2 (6).svg' />
            <br />
            <br />
        </div>
    )
}

export default Events;